import React, { useEffect, useState } from "react";

import "./home.css";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import CardMitra from "../../components/CardMitra";
import CardVisiMisi from "../../components/CardVisiMisi";
import LayananKami from "../../components/CardLayananKami";
import CardPortofolio from "../../components/CardPortofolio";

import AOS from "aos";

export default function Home() {
  const [isActive, setIsActive] = useState("beranda");

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      {/* {isLoading && <Loading />} */}
      <Navbar isActive={isActive} />

      <div className="mainContentOne">
        <div className="details">
          <div className="backgroundImage">
            <div className="container pt-4" data-aos="zoom-in">
              <div className="homeContentTransition">
                <div className="my-auto">
                  <h1 className="fw-bold text-white">
                    Siap untuk MENINGKATKAN
                    <br />
                    <div className="fontCemerlang text-danger">
                      Bisnis Anda menjadi <br /> LEBIH BAIK?
                    </div>
                  </h1>
                  <p
                    style={{
                      letterSpacing: "3px",
                      color: "white",
                    }}
                    className="fs-5"
                  >
                    Outsourcing, Technology, WhatsApp Blast, Event Organizer,
                    <br />
                    Online dan Offline Distribution.
                  </p>
                  <a href="/hubungi-kami">
                    <button className="btn btn-danger">Hubungi Kami</button>
                  </a>
                </div>
                <div className="imageBacgroundContent1 text-end">
                  <img
                    src={require("../../assets/hrm.png")}
                    alt="image1"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 293">
            <path
              fill="#D30032"
              fill-opacity="1"
              d="M0,288L48,288C96,288,192,288,288,245.3C384,203,480,117,576,74.7C672,32,768,32,864,69.3C960,107,1056,181,1152,197.3C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg> */}
          </div>
        </div>
      </div>

      <div className="mainContentTwo py-5">
        <div className="container">
          <div className="backgorundImageVisiMisi">
            {/* <h1 className="text-center fw-bold pb-3">Visi, Misi & Komitmen</h1> */}
            <div className="d-lg-flex d-sm-block">
              <div className="col-lg-6 text-center pt-5" data-aos="fade-right">
                <h1 className="cardTitle fw-bold fs-1">
                  Visi Misi <br />
                  <span className="text-danger"> & </span> <br /> Komitmen
                </h1>
                {/* <div className="cardTitleIcon">
                <ArrowRight size={90} color="#D30032" />
              </div> */}
              </div>

              <div>
                <CardVisiMisi
                  title={"Visi"}
                  image={require("../../assets/visi.png")}
                  width={70}
                  description={
                    "Menjadi perusahaan terbaik dalam bidang pelayanan jasa tenaga kerja profesional dan event management dengan memenuhi harapan pelanggan melalui produk teknologi dan pelayanan yang berkualitas."
                  }
                />
                <CardVisiMisi
                  title={"Komitmen"}
                  image={require("../../assets/komitmen.png")}
                  width={105}
                  description={
                    "Bertanggung jawab atas pekerjaan dari awal hingga akhir dan melayani dengan sepenuh hati"
                  }
                />
                <CardVisiMisi
                  title={"Misi"}
                  image={require("../../assets/misi.png")}
                  width={72}
                  description={
                    "Memberikan tingkat kesempurnaan dalam aspek pelayanan tenaga kerja yang berkualitas dan memelihara kepuasan pelanggan yang bersifat full service dan terspesialisasi sehingga akan fit terhadap segala kondisi dan kebutuhan klien."
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mainContentThree py-3">
        <div className="container" data-aos="fade-down">
          <h1 className="text-center text-white fw-bold">Layanan Kami</h1>
          <p className="text-center fs-4 text-white pb-lg-4">
            Layanan yang kami tawarkan sesuai dengan kebutuhan Anda.
          </p>
          <div className="row row-cols-1 row-cols-md-6 g-3 d-flex justify-content-center">
            <LayananKami
              image={require("../../assets/logo2.png")}
              title={"Aplikasi Phoenix"}
              description={
                "Aplikasi Phoenix merupakan suatu aplikasi/platform canvasing untuk produk-produk retail yang bertujuan untuk mempermudah user dalam mengelola suatu data hasil pelaporan aktivitas canvasing merchandiser (Stok produk, display backwall, dan kondisi produk di toko retail)."
              }
              link={"/aplikasi-phoenix"}
            />
            <LayananKami
              image={require("../../assets/outsourcing.png")}
              title={"Outsourcing"}
              description={
                "3G Indonesia sangat berpengalaman dalam menyediakan jasa tenaga kerja profesional untuk keperluan sales promotion dan marketing 3G Indonesia menangani berbagai kegiatan promosi seperti promosi regular do store, event, branding team, canvasing, dan lainnya."
              }
              link={"/outsourcing"}
            />
            <LayananKami
              image={require("../../assets/onlineDist.png")}
              title={"Online & Offline"}
              description={
                "Dengan Online & Offline Distribution Service dari 3G Indonesia, kami pastikan produk unggulanmu hadir di seluruh jaringan pemasaran sesuai dengan rencana bisnis Anda. Hubungi tim kami untuk diskusi lebih lanjut dan segera maksimalkan penjualan produk unggulanmu Bersama 3G Indonesia."
              }
              link={"/online-offline-distribution"}
            />
          </div>
        </div>
      </div>

      <div className="mainContentFour py-5 p-1">
        <div className="container" data-aos="zoom-in">
          <div>
            <h1 className="text-danger">
              Kenapa harus memilih <span className="fw-bold">KAMI?</span>
            </h1>
            <h2 className="textPartnerBisnis">
              sebagai <span className="fw-bold">PARTNER</span> bisnis anda.
            </h2>
          </div>
          <div className="me-sm-5 pe-sm-5 descriptionMainContentFour">
            <p>
              3G Indonesia sangat berpengalaman dalam menyediakan jasa tenaga
              kerja profesional untuk keperluan sales promotion dan marketing 3G
              Indonesia menangani berbagai kegiatan promosi seperti promosi
              regular di store, event, branding team, canvassing, dan lainnya.
            </p>
            <p>
              Setiap layanan jasa yang ditawarkan oleh 3G Indonesia hadir dengan
              sebuah teknologi baru yang membuat Anda tidak perlu menyediakan
              waktu khusus hanya untuk memonitor kerja tim di lapangan. Aplikasi
              yang dikembangkan oleh 3G Indonesia membuat Anda bisa bersantai
              sambil memonitor kerja tim dan juga mengirimkan tugas hanya dari
              satu tempat saja. Kapanpun, dimanapun.
            </p>
          </div>
        </div>
      </div>

      <div className="mainContentFive py-5">
        <div className="container" data-aos="fade-up">
          <h1 className="text-center pb-3 fw-bold">Mitra Kami</h1>
          <p className="text-center pb-3">
            Client kami dengan Jangkauan wilayah dari Sabang hingga Merauke
            Indonesia
          </p>
          <CardMitra />
        </div>
      </div>

      <div className="mainContentSix">
        <div className="detailsTwo py-5">
          <div className="container" data-aos="zoom-in">
            <h1 className="text-center fw-bold text-white">Jangkauan Kami</h1>
            <div className="text-center">
              <img
                src={require("../../assets/indonesia.png")}
                alt="ImagePeta"
                // className="img-fluid"
                width={950}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mainContentSevent py-5">
        <div className="container" data-aos="fade-up">
          <h1 className="text-center pb-3 fw-bold">Portofolio Kami</h1>
          <CardPortofolio />
        </div>
      </div>
      <Footer />
    </>
  );
}
